import { useTranslation } from "react-i18next";
import {
  enumlicenseactionToI18nKey,
  type EnumLicenseAction,
} from "../../../generated/enums";

/**
 * Couleur par action sur les licences.
 *
 * Volontairement SOBRE, contrairement aux deux autres onglets de l'écran Historique :
 * aucune des deux actions n'est une alerte. Un retrait de licence est une opération
 * normale (réaffectation, résiliation) — le colorer en rouge ferait croire à un
 * problème et noierait le signal des autres onglets.
 *
 * ⚠️ Palette réelle du projet : `bg-primary` et `amber-*` N'EXISTENT PAS dans
 * tailwind.config.js. Une classe inconnue ne lève aucune erreur, elle rend juste la
 * pastille sans fond.
 */
const ACTION_CLASSES: Record<EnumLicenseAction, string> = {
  license_granted: "bg-secondary text-white",
  license_revoked: "bg-grey-medium text-white",
};

/**
 * Pastille d'action. Le libellé traduit est TOUJOURS présent : la couleur seule n'est
 * pas une information accessible (daltonisme, impression noir et blanc).
 */
export const LicenseActionBadge = ({
  action,
}: {
  action: EnumLicenseAction;
}) => {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${ACTION_CLASSES[action]}`}
    >
      {t(enumlicenseactionToI18nKey[action])}
    </span>
  );
};
